import usingServiceAdvantage from './usingCafesAdvantage';
import frequentlyAskedQuestions from './cafes-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'Cafe POS',
      description: `Serve up the morning fix with an intuitive, easy-to-use POS – now with flexible payment options.`,
    },
    zh: {
      title: '咖啡厅',
      description: 'Chowbus POS—-最佳咖啡伴侣，伴您轻松度过忙碌的早晨',
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommended products to power your Cafe',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
